import apiClient from 'api/client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

const TRACEABILITY_USER = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TRACEABILITY,
  VERSIONS.V1,
  RESOURCES.USER,
  false
);

export const traceabilityUserApi = {
  traceabilityUserForm: () => apiClient.get(`${TRACEABILITY_USER}/form`),

  editTraceabilityUserForm: Id =>
    apiClient.get(`${TRACEABILITY_USER}/form?is_edit=true&user_id=${Id}`),

  createTraceabilityUser: combinedData =>
    apiClient.post(`${TRACEABILITY_USER}`, combinedData),

  updateTraceabilityUser: (id, combinedData) =>
    apiClient.put(`${TRACEABILITY_USER}/${id}`, combinedData)
};
